import { initializeApp } from 'firebase/app';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { initializeAppCheck, ReCaptchaV3Provider } from 'firebase/app-check';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID
};

let app;
let auth;
let db;

try {
  // Check if all required environment variables are present
  const missingVars = Object.keys(firebaseConfig)
    .filter(key => !firebaseConfig[key]);
  
  if (missingVars.length > 0) {
    console.error('❌ Missing Firebase environment variables:', missingVars);
    // Don't log the full config to avoid exposing API keys
    throw new Error(`Missing Firebase environment variables: ${missingVars.join(', ')}`);
  }

  console.log('✅ Firebase config loaded successfully');
  
  // Initialize Firebase
  app = initializeApp(firebaseConfig);

  // Initialize Firestore with specific database name
  db = getFirestore(app, 'sydneyferriscom');

  auth = getAuth(app);
  console.log('✅ Firebase auth initialized successfully');

  // Connect to emulators in development (only if not using production credentials)
  if (process.env.NODE_ENV === 'development' && process.env.REACT_APP_USE_EMULATORS === 'true') {
    try {
      connectAuthEmulator(auth, 'http://localhost:9099');
      connectFirestoreEmulator(db, 'localhost', 8080);
      console.log('Connected to Firebase emulators');
    } catch (emulatorError) {
      console.warn('Failed to connect to emulators:', emulatorError);
    }
  }

  // Initialize App Check
  if (process.env.NODE_ENV === 'production' && process.env.RECAPTCHA_SITE_KEY) {
    try {
      initializeAppCheck(app, {
        reCaptchaV3SiteKey: process.env.RECAPTCHA_SITE_KEY,
        provider: new ReCaptchaV3Provider(process.env.RECAPTCHA_SITE_KEY),
        isTokenAutoRefreshEnabled: true
      });
    } catch (appCheckError) {
      console.warn('Failed to initialize App Check:', appCheckError);
    }
  }
} catch (error) {
  console.error('Firebase initialization error:', error);
  // Create minimal fallback objects to prevent app crashes
  app = null;
  auth = null;
  db = null;
}

export { db, auth };
export default app;
